import 'bootstrap';
import { createApp } from 'vue';
import { createPinia } from 'pinia';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import '@fortawesome/fontawesome-free/css/all.css';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faBars, faListOl, faEnvelope, faBell, faCaretDown,
} from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';

/* add icons to the library */
library.add(faBars, faListOl, faEnvelope, faBell, faCaretDown);

import jQuery from 'jquery';
declare global{
  interface Window {
    $:typeof jQuery
  }
}
window.$ = jQuery

const pinia = createPinia();

createApp(App).use(router).use(pinia).use(ElementPlus)
  .use(VueAxios, axios)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app');
